import React from "react";

const Pages = () => {
    return (
        <>
            <div className="pages bg">
                <div className="left">
                    <div className="box box1">Music Therapy</div>
                    <div className="box box2">Pets Recommendation</div>
                    <div className="box box3">Book Recommendation</div>
                </div>
                <div className="line">
                    <div className="dot"></div>
                </div>
                <div className="right">
                    <div className="box box4">Group Counselling</div>
                    <div className='box box5'>Therapy Session</div>
                    <div className="box box6">Yoga/ Meditation</div>
                </div>
            </div>
        </>
    )
}

export default Pages